import React from "react"
import { Link as GatsbyLink } from "gatsby"

import Layout from "../components/layouts/layout"
import SEO from "../components/seo"
import {
  ThemeProvider,
  CssBaseline,
  useTheme,
  Button,
  Box,
  Typography,
} from "@material-ui/core"

import theme from "../utility/theme"
import GeneralSection from "../components/layouts/general-section"
import ServiceList from "../components/service-list"
import Quote from "../components/quote"
import ArticleSection from "../components/layouts/article-section"

const IndexPage = () => {
  const theme = useTheme()
  const mailHref = `mailto:${theme.data.mail}`

  return (
    <Layout data={theme.data.pages.index}>
      <SEO title="Home" />
      <GeneralSection
        variant="h2"
        heading="FOR YOUR SMALL AND BIG BUSINESS"
        headingmb="50px"
        mb={12.5}
        classes={{ root: "service-heading" }}
      >
        <Box px={2.5}>
          <ServiceList />
          <Box textAlign="center" marginTop={7.5}>
            <Button
              component={GatsbyLink}
              to="/about"
              color="secondary"
              variant="contained"
            >
              KNOW MORE
            </Button>
          </Box>
        </Box>
      </GeneralSection>
      <GeneralSection mb={12.5}>
        <Quote
          imgName="quote-bg.jpg"
          quote='"We want to continue being accountants because our client’s satisfaction drives us to continue in this path. This is something that we truly enjoy and we are very passionate about it."'
          author="~ Efficient Accounting Team"
        />
      </GeneralSection>
      <ArticleSection
        heading="WE WILL BE ACCOUNTABLE WITH YOU"
        headingVariant="h2"
        primaryLabel="CONTACT US"
        primaryHref={mailHref}
        mb="100px"
      >
        <Typography>
          We are here to listen to you first then try to solve and manage the
          problems with you. No matter how big or small your problem may be, we
          are still here all the way, specially on tax day. In our world, size
          does not matter.
        </Typography>
      </ArticleSection>
    </Layout>
  )
}

const StyledIndexPage = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <IndexPage />
  </ThemeProvider>
)

export default StyledIndexPage
